import { gql } from '@apollo/client';

export const UPSERT_FRAMEWORKRESULTINDICATOR = gql`
  mutation upsertFrameworkResultIndicator($input: UpsertFrameworkResultIndicatorInput!) {
    indicator: upsertFrameworkResultIndicator(input: $input) {
      id
      dimensions {
        id
        index
      }
      benchmarks {
        id
        index
      }
      periods {
        id
        periodDate
        periodNumber
      }
      targets {
        id
        periodDate
        periodNumber
        dimensionOptions
      }
    }
  }
`;
